import {Collection} from './Collection';
import {Model} from './Model';
import {OrderItemProduct} from './OrderItemProduct';
import {Product} from './Product';
import {Fabric} from './Fabric';
import {OrderItemOption} from './OrderItemOptions';
import {SummaryOption} from './SummaryOption';
import {Style} from './Style';

export class OrderItem {
  public id: number;
  public collection: number | Collection|any;

  public model: Model | number|any;
  public style: number | Style|any;

  public collections: Collection[] = [];
  public models: Model[] = [];
  public styles: Style[] = [];

  public modelObj: Model;
  public styleObj: Style;
  public collectionObj: Collection;
  public products: Product[] = [];
  public oldProducts: number[] = [];

  public articleOptionsListToSelect = [];
  public selectedOptions = [];
  public selectedSummaryOptions = [];
  public orderItemOptions: OrderItemOption[] = [];
  public summaryOptions: SummaryOption[] = [];

  public fabrics: Fabric[] = [];
  public orderItemProducts: OrderItemProduct[] = [];
  public totalDealerPrice?: number;
  public totalCustomerPrice?: number;
  public random: number;

  public totalArticleCustomerPrice?: number;
  public totalArticleDealerPrice?: number;

  constructor() {
    this.orderItemProducts.push(new OrderItemProduct());
  }
}
